import { useState } from "react";
import { DataFile } from "interfaces";

import Modal from "ui-components/Modal";
import Button from "ui-components/Button";

import { useFetchCreationChain } from "modules/data-files/api";

import Form from "./Form";

interface Props {
  dataFile: DataFile.DataFile;
  className?: string;
  buttonColor?: "primary" | "secondary" | "danger" | "gray";
  buttonSize?: "small" | "medium" | "large";
}

const supportedTransforms = [
  "CLEANUP",
  "TRANSFORM",
  "TIME-SERIES",
  "AGGREGATE",
  "AUGMENT",
  "FILTER",
  "FLATTEN",
];

const CreateDataFileMacro = ({
  dataFile,
  className,
  buttonColor,
  buttonSize,
}: Props) => {
  const [isOpen, setOpen] = useState(false);
  const { data: creationChain } = useFetchCreationChain(dataFile.id);
  if (!supportedTransforms.includes(dataFile.create_type)) {
    return null;
  }

  if (!creationChain) {
    return null;
  }

  if (creationChain && Object.keys(creationChain).length === 0) {
    return null;
  }

  return (
    <>
      <p className={className}>
        <Button
          onClick={() => setOpen(true)}
          color={buttonColor}
          size={buttonSize}
        >
          Make Macro
        </Button>
      </p>
      <Modal
        id="make-macro"
        title={`Make Macro using ${dataFile.name}`}
        show={isOpen}
        handleClose={() => setOpen(false)}
      >
        <Form
          dataFile={dataFile}
          close={() => setOpen(false)}
          creationChain={creationChain}
        />
      </Modal>
    </>
  );
};

export default CreateDataFileMacro;
